import { BsAward, BsTrophy } from 'react-icons/bs';
import { FaHardHat, FaRegBuilding, FaToolbox, FaUsers } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';

const timeLineData = [
    {
        id: uuidv4(),
        year: 2017,
        icon: <FaRegBuilding />,
        heading: 'Înființarea Work Express',
        text: 'Lansarea oficială a companiei Work Express, cu focus pe servicii de construcții și renovări de înaltă calitate în București.',
        transform: '',
    },

    {
        id: uuidv4(),
        year: 2018,
        icon: <FaUsers />,
        heading: 'Extinderea Echipei',
        text: 'Angajarea primilor muncitori calificați și formarea echipei de bază, specializată în izolații, instalații electrice și finisaje.',
        transform: 'transform-bottom',
    },

    {
        id: uuidv4(),
        year: 2019,
        icon: <FaToolbox />,
        heading: 'Diversificarea Serviciilor',
        text: 'Adăugarea de noi servicii: gips-carton, tencuieli și șape, montaj pardoseli, consolidând poziția pe piața de renovări.',
        transform: '',
    },

    {
        id: uuidv4(),
        year: 2020,
        icon: <BsAward />,
        heading: 'Certificare ISO',
        text: 'Obținerea certificărilor ISO pentru calitate și siguranță în construcții, confirmând standardele înalte de lucru.',
        transform: 'transform-bottom',
    },

    {
        id: uuidv4(),
        year: 2022,
        icon: <FaHardHat />,
        heading: 'Tehnologii Avansate',
        text: 'Implementarea tehnologiilor HVAC și IBIX, oferind soluții moderne și ecologice pentru termoizolații și instalații climatizare.',
        transform: '',
    },

    {
        id: uuidv4(),
        year: 2024,
        icon: <BsTrophy />,
        heading: 'Peste 500 de Proiecte',
        text: 'Atingerea pragului de 500 de proiecte finalizate cu succes, consolidând reputația de partener de încredere în construcții.',
        transform: 'transform-bottom',
    },

    {
        id: uuidv4(),
        year: 2025,
        icon: <FaRegBuilding />,
        heading: 'Expansiune Regională',
        text: 'Extinderea serviciilor în Ilfov și județele limitrofe, cu planuri ambițioase de creștere și dezvoltare continuă.',
        transform: '',
    },
];

export default timeLineData;
